import { render, staticRenderFns } from "./TermsServices.vue?vue&type=template&id=674f6816&"
import script from "./TermsServices.vue?vue&type=script&lang=js&"
export * from "./TermsServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports